import React, { useEffect } from "react";

const VentasPOSPage = () => {
  useEffect(() => {
    document.title = "Ventas - POS | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">POS (Punto de venta)</h4>
            <p className="text-muted mb-0">
              Esta sección será utilizada para centralizar las operaciones del punto de venta.
              Pronto vas a poder visualizar y gestionar terminales, sesiones y ventas en tiempo real.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VentasPOSPage;
